import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

interface WrapperProps {
  isDisabled?: boolean;
}

interface IconWrapperProps {
  isDisabled?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  background-color: var(--color-set-brand-bg-color, var(--t-brand-bg-color, #ffffff));
  border: 1px solid var(--color-set-horizontal-vertical-rule, var(--t-horizontal-vertical-rule, #c4c4c4));
  border-radius: var(--border-radius-cards-border-radius, 14px);
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);
  cursor: pointer;
  transition: border-color 0.2s ease;
  width: 100%;
  box-sizing: border-box;

  &:focus-within {
    border-color: var(--color-set-button-primary-border-color, var(--t-brand-fg-color, #1c1c1c));
    outline: none;
  }

  ${({ isDisabled }) =>
    isDisabled &&
    `
    background-color: var(--colors-neutral-10, ${baseVariables.color.neutral10});
    cursor: not-allowed;
    box-shadow: none;

    &:focus-within {
      border-color: var(--color-set-horizontal-vertical-rule, ${baseVariables.color.neutral30});
    }
  `}
`;

export const IconWrapper = styled.button<IconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  color: var(--t-brand-fg-color, #1c1c1c);

  /* Icon size */
  [class^='icon-'],
  [class*=' icon-'] {
    font-size: 24px;
  }

  ${chatKeyboardFocusVisible}

  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: var(--colors-neutral-40, ${baseVariables.color.neutral40});
    cursor: not-allowed;
    pointer-events: none;
  `}
`;

export const InputWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;

  /* Override global .m-input-field styles for chat context */
  .m-input-field {
    width: 100%;
    display: flex;
    align-items: center;

    textarea {
      width: 100%;
      border: none !important;
      background: transparent;
      outline: none !important;
      padding: 0 !important;
      margin: 0;
      min-height: 24px;
      line-height: 24px;
      box-sizing: border-box;
      color: var(--t-brand-fg-color, #1c1c1c);
      caret-color: var(--t-brand-fg-color, #1c1c1c);
      font-size: 14px;
      overflow-y: hidden;
      resize: none;

      @media (max-width: 992px) {
        font-size: 16px !important; /* Prevent iOS zoom on focused textarea */
      }

      &::placeholder {
        color: var(--t-brand-alt-color, #707070);
      }

      &:focus {
        outline: none !important;
        border: none !important;
        box-shadow: none !important;

        @media (max-width: 992px) {
          font-size: 16px !important;
        }
      }

      &:focus-visible {
        outline: none !important;
        box-shadow: none !important;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
`;
